import { IconButton } from '@affine/component';
import {
  EraserIcon,
  ExportToPdfIcon,
  HandIcon,
  HighLightDuotoneIcon,
  PenIcon,
  TextIcon,
} from '@blocksuite/icons/rc';
import type { ReactElement, SVGAttributes } from 'react';

import type { PdfEditMode } from './edit-overlay';
import * as styles from './edit-styles.css';

const MODES: Array<{
  mode: PdfEditMode;
  icon: ReactElement<SVGAttributes<SVGElement>>;
  tooltip: string;
}> = [
  { mode: 'view', icon: <HandIcon />, tooltip: 'View' },
  { mode: 'text', icon: <TextIcon />, tooltip: 'Edit text' },
  { mode: 'draw', icon: <PenIcon />, tooltip: 'Draw' },
  { mode: 'highlight', icon: <HighLightDuotoneIcon />, tooltip: 'Highlight' },
  { mode: 'erase', icon: <EraserIcon />, tooltip: 'Erase edit' },
];

export const PdfEditToolbar = ({
  mode,
  onModeChange,
  onExport,
  exporting,
}: {
  mode: PdfEditMode;
  onModeChange: (mode: PdfEditMode) => void;
  onExport: () => void;
  exporting: boolean;
}) => {
  return (
    <div className={styles.toolbar} data-testid="pdf-edit-toolbar">
      {MODES.map(item => (
        <IconButton
          key={item.mode}
          className={styles.toolbarButton}
          data-active={mode === item.mode}
          tooltip={item.tooltip}
          icon={item.icon}
          onClick={() => onModeChange(item.mode)}
        />
      ))}
      <div className={styles.toolbarDivider} />
      <IconButton
        className={styles.toolbarButton}
        tooltip="Export edited PDF"
        icon={<ExportToPdfIcon />}
        disabled={exporting}
        onClick={onExport}
      />
    </div>
  );
};
